import { types } from '../types/types';
import { signIn, logOut } from "../controllers/basicAuth";
import { startLoading, finishLoading } from './ui';

export const startLoginEmailPassword = (userName,userPassword,history) => {
    return (dispatch) => {
        dispatch( startLoading() );
        
        const lastPath = localStorage.getItem('lastPath') || '/home';
        let dataLog =  signIn(userName,userPassword);
            dataLog.then((e)=>{
                dispatch(login(e.data.user.id,e.data.user.name,e.data.access_token))
                dispatch( finishLoading() );
                history.replace( lastPath );
            })
            .catch((e)=>{
                console.warn(e);
                dispatch( finishLoading() );
            });
    }
}

export const login = (id, name, languaje) => {
    return {
        type: types.login,
        payload: {
            id,
            name,
            languaje
        }
    }
}

export const logout = (token) => {
    logOut(token);
   return {type: types.logout}
}